// extracted by mini-css-extract-plugin
export default {"report_link":"ReportOverview_report_link__XCjwt"};